import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import moment from 'moment';
import { Moment } from 'moment';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

import { Snapshot } from '@vi-iot/client';

import {
  FeatureService,
  Gateway,
  RemoteDiagnosticsSnapshotsStore,
  SHOW_MORE_BACKUPS_THRESHOLD,
} from '@store';

@Component({
  selector: 'app-backup-list',
  templateUrl: './backup-list.component.html',
  styleUrls: ['./backup-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackupListComponent implements OnInit, OnDestroy {
  SHOW_MORE_BACKUPS_THRESHOLD = SHOW_MORE_BACKUPS_THRESHOLD;
  gatewayProperties$: Observable<Gateway>;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  displayedBackups: Snapshot[] = [];
  constructor(
    public remoteDiagnosticsSnapshotsStore: RemoteDiagnosticsSnapshotsStore,
    private featureService: FeatureService
  ) {}

  ngOnInit(): void {
    this.remoteDiagnosticsSnapshotsStore.setFilteredDate(moment());
    this.gatewayProperties$ = this.featureService.selectGatewayProperties();

    this.remoteDiagnosticsSnapshotsStore.snapshotsFiltered$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((list) => {
        this.displayedBackups = list;
      });
  }

  changeDate(date: Moment): void {
    this.remoteDiagnosticsSnapshotsStore.setFilteredDate(date);
    this.remoteDiagnosticsSnapshotsStore.selectSnapshot(null);
  }

  toggleShowMoreBackups(): void {
    this.remoteDiagnosticsSnapshotsStore.isShowingMoreSnapshots$
      .pipe(take(1))
      .subscribe((showMore) => {
        if (!showMore) {
          this.remoteDiagnosticsSnapshotsStore.showMoreSnapshots();
        } else {
          this.remoteDiagnosticsSnapshotsStore.showLessSnapshots();
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.remoteDiagnosticsSnapshotsStore.showLessSnapshots();
  }
}
